import getImageAttributes from '../../../../cms/utils/get-image-attributes';

// @ts-expect-error - Automatic, Please fix when editing this file
const getOfferImage = (offer) => {
  const imageObject = offer?.offerTypes?.[0]?.imageObject;
  return getImageAttributes({ imageObject, width: 400 });
};

export default getOfferImage;
